/**
 * Marcadores de la empresa (T031 · US1).
 *
 * `validateSearch` acepta `site_id` y `status` en la query (`/marcadores?site_id=…`, el enlace del
 * detalle de una sede). Lo que no encaje se descarta: la pantalla arranca sin ese filtro en vez de
 * romperse con una URL manipulada.
 */
import { createFileRoute } from '@tanstack/react-router';

import { TerminalStatus } from '@fermin/contracts';

import { TerminalsPage } from '../../features/terminals/terminals-page';

export interface TerminalsSearch {
  site_id?: string;
  status?: TerminalStatus;
}

export const Route = createFileRoute('/_app/marcadores')({
  validateSearch: (search: Record<string, unknown>): TerminalsSearch => {
    const siteId = typeof search['site_id'] === 'string' ? search['site_id'] : undefined;
    const status = TerminalStatus.safeParse(search['status']);
    return {
      ...(siteId ? { site_id: siteId } : {}),
      ...(status.success ? { status: status.data } : {}),
    };
  },
  component: function TerminalsRoute() {
    const { site_id: siteId, status } = Route.useSearch();
    return <TerminalsPage siteId={siteId} status={status} />;
  },
});
